'use strict';

var jsxRuntime = require('react/jsx-runtime');
var Typography = require('../../Base/Typography/Typography.js');
require('../../Base/Layouts/Box/Box.js');
require('tailwind-merge');
require('../../Base/Layouts/FullBleed/FullBleed.js');

// return A ~ Z
const INDEXES = Array.from({
    length: 26
}, (_, i)=>String.fromCharCode(65 + i));
const IndexBar = ({ onIndexClick })=>{
    return jsxRuntime.jsx("ul", {
        className: "flex flex-col gap-0.5 rounded-l-xl bg-w-gray-10 p-[3px] text-center",
        children: INDEXES.map((index)=>jsxRuntime.jsx("li", {
                className: "size-3.5 cursor-pointer",
                onClick: ()=>onIndexClick === null || onIndexClick === void 0 ? void 0 : onIndexClick(index),
                children: jsxRuntime.jsx(Typography, {
                    variant: "caption2",
                    className: "text-gray-400",
                    children: index
                })
            }, index))
    });
};
const Icon = ({ iconUrl })=>{
    return jsxRuntime.jsx("img", {
        src: iconUrl,
        alt: "icon",
        width: 24,
        height: 24,
        className: "rounded-full border"
    });
};
const TextSection = ({ text, isInputItem, inputValue })=>{
    const coloredText = text.slice(0, inputValue === null || inputValue === void 0 ? void 0 : inputValue.length);
    const restText = text.slice(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length);
    return jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: isInputItem ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs(Typography, {
                    variant: "body1",
                    className: "font-medium text-primary-500",
                    "data-testid": "design-system-list-item-text",
                    children: [
                        "\u2018",
                        text,
                        "\u2019"
                    ]
                }),
                jsxRuntime.jsx(Typography, {
                    variant: "body1",
                    className: "text-w-gray-600",
                    children: "\uC785\uB825"
                })
            ]
        }) : jsxRuntime.jsx(Typography, {
            variant: "body1",
            className: "text-w-gray-600",
            "data-testid": "design-system-list-item-text",
            children: inputValue ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [
                    jsxRuntime.jsx(Typography, {
                        variant: "body1",
                        className: "text-primary",
                        children: coloredText
                    }),
                    restText
                ]
            }) : text
        })
    });
};
const CountSection = ({ count })=>{
    return jsxRuntime.jsx(Typography, {
        variant: "body1",
        className: "text-w-gray-400",
        children: count
    });
};

exports.CountSection = CountSection;
exports.INDEXES = INDEXES;
exports.Icon = Icon;
exports.IndexBar = IndexBar;
exports.TextSection = TextSection;
